<template>
  <div class="rich-text-container">
    <div v-html="content"></div>
  </div>
</template>

<script>
export default {
  props: ['html'],
  name: 'RichText',
  computed: {
    content () {
      const prefix = ((this.$baseURL || '').replace(/\/+$/, '')) + '/common/service/'
      const html = (this.html || '').replace(
        /(<img\b[^>]*\bsrc\s*=\s*["'])[^"']*?(?=getFile)/gi,
        (_, pre) => pre + prefix
      ).replace(
        /(<(?:video|source|iframe|embed|object)\b[^>]*\bsrc\s*=\s*["'])[^"']*?(?=getFile)/gi,
        (_, pre) => pre + prefix
      )
      return html
    }
  }
}
</script>

<style lang="less">
.rich-text-container {
  /* 默认：大图等比缩放到容器宽，不放大小图 */
  img {
    max-width: 100% !important;
    height: auto !important;
  }

  /* 使视频、iframe、audio 等媒体元素响应屏幕宽度 */
  video,
  iframe,
  embed,
  object {
    max-width: 100% !important;
    width: 100% !important;
    height: auto !important;
    display: block; /* 去除 inline 间距 */
  }

  /* 音频控件也占满容器宽度 */
  audio {
    width: 100% !important;
  }

  /* 为 iframe / video 指定默认纵横比，支持现代浏览器 */
  iframe,
  video {
    aspect-ratio: 16/9;
  }

  table {
    border-collapse: collapse; /* 合并边框，避免双线 */
    border: 1px solid #888; /* 外框线 */
    th,
    td {
      border: 1px solid #888; /* 单元格边框 */
    }
    th {
      background: #f5f5f5; /* 可选：表头背景色 */
      padding: 10px 0;
    }
  }
}

/* 屏幕 ≤ 500px 时，强制覆盖内联 width 百分比 */
@media screen and (max-width: 768px) {
  .rich-text-container img {
    width: 100% !important; /* 覆盖内联 width="50%" */
    max-width: 100% !important;
    height: auto !important;
  }
  .rich-text-container video,
  .rich-text-container iframe,
  .rich-text-container embed,
  .rich-text-container object {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
  }
  .rich-text-container audio {
    width: 100% !important;
  }
}
</style>
